import { getGooglePredictions } from 'utils/google-maps';
import { processPredictions } from './utils';
import { QuerySettingsType } from 'utils/google-maps/types';
import { SearchStrategyProps, SearchResult } from './SearchStrategy';
import { CountryCode } from 'types/countries';
import { BaseSearchStrategy } from './BaseSearchStrategy';
import SearchPrediction from 'data/search-predictions';
import { ZOOCASA_TENANT_ID } from 'tenants';

export class DefaultSearchStrategy extends BaseSearchStrategy {
  /**
   * Process search results for the default search strategy
   */
  protected async processSearchResults(goSearchPredictions: SearchPrediction[], props: SearchStrategyProps): Promise<SearchResult> {
    const { queryString, useUsListings = false, siteLocation, themeName } = props;

    // Google query settings
    // We do not ask Google for provinces, but we still need to pass a value to satisfy the type.
    const googleQuerySettings: QuerySettingsType = {
      limits: {
        city: 10, neighborhood: 0, street: 10, province: 1,
      },
    };

    // Get predictions from Google Maps
    const googleSearchPredictions = await getGooglePredictions(
      queryString,
      (useUsListings && themeName === ZOOCASA_TENANT_ID),
      siteLocation as CountryCode,
      googleQuerySettings
    );

    // Process and combine predictions
    const finalPredictions = processPredictions(goSearchPredictions, googleSearchPredictions);

    return {
      searchPredictions: finalPredictions,
      searchAgentPredictions: [],
    };
  }
}